/* cb'dé slide cart — logique (remplace AMP). ~léger. Section Rendering API pour rester traduit. */
(function(){
  /* jamais la page /cart fixe : on redirige vers l'accueil (locale conservée) en ouvrant le drawer */
  try{ if(/\/cart\/?$/.test(location.pathname)){ location.replace(location.pathname.replace(/\/cart\/?$/,'/') + '?cc_open=1'); return; } }catch(e){}
  var SECTION = 'cbde-cart-drawer';
  var root, body, applied = { code:'' };
  var annTimer = null;

  function el(){ root = document.getElementById('cbde-cart'); body = root && root.querySelector('[data-cc-body]'); return !!root; }

  function open(){ if(!el()) return; root.classList.add('is-open'); document.documentElement.style.overflow='hidden'; startAnnounce(); }
  function close(){ if(!root) return; root.classList.remove('is-open'); document.documentElement.style.overflow=''; stopAnnounce(); }

  function esc(x){ return (x==null?'':(''+x)).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function money(cents){ return (cents/100).toFixed(2).replace('.',',') + ' €'; }

  function updateProgress(total){
    var prog = root && root.querySelector('[data-cc-prog]'); if(!prog) return;
    var stops = [].slice.call(root.querySelectorAll('.cc-stop'));
    if(!stops.length) return;
    var pts = stops.map(function(st){ return { amt: parseInt(st.getAttribute('data-amount'),10)||0, pos: parseFloat(st.style.left)||0, el: st, rew: st.getAttribute('data-reward')||'' }; }).sort(function(a,b){ return a.amt-b.amt; });
    /* fill interpolé : segments entre repères espacés uniformément (segment virtuel [0€;0%] -> 1er palier) */
    var bounds = [{amt:0,pos:0}].concat(pts);
    var last = bounds[bounds.length-1], fillPct = 0;
    if(total >= last.amt){ fillPct = 100; }
    else { for(var i=0;i<bounds.length-1;i++){ if(total >= bounds[i].amt && total < bounds[i+1].amt){ var span=(bounds[i+1].amt-bounds[i].amt)||1; var seg=(total-bounds[i].amt)/span; fillPct = bounds[i].pos + seg*(bounds[i+1].pos-bounds[i].pos); break; } } }
    var fill = root.querySelector('[data-cc-fill]'); if(fill) fill.style.width = Math.round(fillPct)+'%';
    var nextAmt=0, nextReward='';
    pts.forEach(function(p){ if(total>=p.amt){ p.el.classList.add('done'); } else { p.el.classList.remove('done'); if(nextAmt===0){ nextAmt=p.amt; nextReward=p.rew; } } });
    var lead = root.querySelector('[data-cc-prog-lead]');
    if(lead){
      if(nextAmt>0){ lead.innerHTML = esc(prog.getAttribute('data-prefix'))+' <b>'+money(nextAmt-total)+'</b> '+esc(prog.getAttribute('data-suffix'))+' '+esc(nextReward)+' !'; }
      else { lead.textContent = prog.getAttribute('data-done')||''; }
    }
  }

  function swapBody(html, total){
    try{
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nb = doc.querySelector('[data-cc-body]');
      var nc = doc.querySelector('[data-cc-count]');
      if(nb && body){ body.innerHTML = nb.innerHTML; }
      if(nc){ var c=root.querySelector('[data-cc-count]'); if(c) c.textContent = nc.textContent; }
      if(typeof total === 'number'){ updateProgress(total); }
      bindBody();
    }catch(e){}
  }

  function refresh(){
    return Promise.all([
      fetch('/?sections='+SECTION, {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}),
      fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();})
    ]).then(function(a){ if(a[0][SECTION]) swapBody(a[0][SECTION], a[1].total_price); });
  }

  function change(line, qty){
    return fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: line, quantity: qty, sections: SECTION })})
      .then(function(r){return r.json();}).then(function(j){ if(j.sections && j.sections[SECTION]) swapBody(j.sections[SECTION], j.total_price); });
  }

  function addVariant(id){
    return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{id:parseInt(id,10), quantity:1}], sections: SECTION })})
      .then(function(){ return refresh(); });
  }

  var noteT=null;
  function saveNote(v){ clearTimeout(noteT); noteT=setTimeout(function(){ fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:v})}); }, 500); }

  function renderPromoChips(){
    var box = root && root.querySelector('[data-cc-promo-chips]'); if(!box) return;
    var row = root.querySelector('[data-cc-promo-row]');
    if(applied.code){
      box.innerHTML = '<span class="cc-chip" title="Appliqué au paiement">🏷️ '+esc(applied.code)+'<button class="cc-chip-x" data-cc-chip-remove aria-label="Retirer">×</button></span>';
      if(row) row.style.display='none';
      var x=box.querySelector('[data-cc-chip-remove]'); if(x) x.onclick=removePromo;
    } else {
      box.innerHTML=''; if(row) row.style.display='';
    }
  }
  function removePromo(){ applied.code=''; try{ localStorage.removeItem('cbde_promo'); }catch(e){} renderPromoChips(); }
  function applyPromo(){
    var inp=root.querySelector('[data-cc-promo-input]'); var v=(inp&&inp.value||'').trim(); if(!v) return;
    var err=root.querySelector('[data-cc-promo-err]');
    var rules=root.querySelector('[data-cc-promo-rules]');
    var rule=null;
    if(rules){ var cu=v.toUpperCase(); [].forEach.call(rules.querySelectorAll('span[data-code]'), function(s){ if(s.getAttribute('data-code')===cu) rule=s; }); }
    function showErr(msg){ if(err){ err.textContent=msg; err.style.display=''; } }
    function ok(){ if(err) err.style.display='none'; applied.code=v; try{ localStorage.setItem('cbde_promo', v); }catch(e){} renderPromoChips(); }
    if(!rule){ ok(); return; } /* code non configuré → on laisse le checkout valider */
    var min=parseInt(rule.getAttribute('data-min'),10)||0;
    var exclude=parseInt(rule.getAttribute('data-exclude'),10)||0;
    var msg=rule.getAttribute('data-msg')||'Conditions du code non respectées.';
    if(exclude>0){ var bad=false; [].forEach.call(root.querySelectorAll('[data-cc-line]'), function(li){ if((parseInt(li.getAttribute('data-disc'),10)||0) > exclude) bad=true; }); if(bad){ showErr(msg); return; } }
    if(min>0){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ if((c.total_price||0) < min){ showErr(msg); } else { ok(); } }).catch(ok); }
    else { ok(); }
  }

  /* ---- announce carousel ---- */
  function startAnnounce(){
    stopAnnounce();
    var items = root ? root.querySelectorAll('.cc-ann-item') : [];
    if(items.length<2) return;
    annTimer = setInterval(function(){ annStep(1); }, 4500);
  }
  function stopAnnounce(){ if(annTimer){ clearInterval(annTimer); annTimer=null; } }
  function annStep(dir){
    var items = root.querySelectorAll('.cc-ann-item'); if(!items.length) return;
    var cur=0; items.forEach(function(it,i){ if(it.style.display!=='none') cur=i; it.style.display='none'; });
    var nx=(cur+dir+items.length)%items.length; items[nx].style.display='';
  }

  /* ---- bind body-level controls (after each render) ---- */
  function bindBody(){
    if(!root) return;
    root.querySelectorAll('[data-cc-line]').forEach(function(row){
      var line = parseInt(row.getAttribute('data-cc-line'),10);
      var q = parseInt((row.querySelector('[data-cc-qty]')||{}).textContent||'1',10);
      var minus=row.querySelector('[data-cc-minus]'), plus=row.querySelector('[data-cc-plus]'), rm=row.querySelector('[data-cc-remove]');
      if(minus) minus.onclick=function(){ change(line, Math.max(0,q-1)); };
      if(plus) plus.onclick=function(){ change(line, q+1); };
      if(rm) rm.onclick=function(){ change(line, 0); };
    });
    root.querySelectorAll('[data-cc-xs-add]').forEach(function(b){ b.onclick=function(){ b.disabled=true; b.textContent='…'; addVariant(b.getAttribute('data-vid')); }; });
    var nt=root.querySelector('[data-cc-note-toggle]'); if(nt) nt.onclick=function(){ nt.closest('[data-cc-note]').classList.toggle('is-open'); var f=root.querySelector('[data-cc-note-field]'); if(f) f.focus(); };
    var nf=root.querySelector('[data-cc-note-field]'); if(nf) nf.oninput=function(){ saveNote(nf.value); };
    var pa=root.querySelector('[data-cc-promo-apply]'); if(pa) pa.onclick=applyPromo;
    renderPromoChips();
    var cgv=root.querySelector('[data-cc-cgv]'), pay=root.querySelector('[data-cc-checkout]');
    if(cgv&&pay){ cgv.onchange=function(){ pay.disabled=!cgv.checked; }; }
    if(pay){ pay.onclick=function(){ if(pay.disabled) return; var url = applied.code ? ('/discount/'+encodeURIComponent(applied.code)+'?redirect=/checkout') : '/checkout'; window.location.href=url; }; }
    root.querySelectorAll('[data-cc-ann-prev]').forEach(function(b){ b.onclick=function(){ annStep(-1); }; });
    root.querySelectorAll('[data-cc-ann-next]').forEach(function(b){ b.onclick=function(){ annStep(1); }; });
    renderXs();
    renderGifts();
    syncX2();
  }

  function renderXs(){
    var data = root && root.querySelector('[data-cc-xs-data]');
    var xs = root && root.querySelector('[data-cc-xs]');
    var slot = root && root.querySelector('[data-cc-xs-slot]');
    if(!xs || !slot) return;
    var items = data ? data.querySelectorAll('span[data-v]') : [];
    if(!items.length){ xs.style.display='none'; return; }
    var addLabel = xs.getAttribute('data-add-label') || 'AJOUTER';
    var inCart = {};
    root.querySelectorAll('[data-cc-line]').forEach(function(li){ /* rien : on autorise même si déjà au panier */ });
    slot.innerHTML = [].map.call(items, function(sp){
      return '<div class="cc-xrow"><a href="'+esc(sp.getAttribute('data-u'))+'"><img src="'+esc(sp.getAttribute('data-i'))+'" alt="" width="42" height="42" loading="lazy"></a>'+
        '<div class="xi"><a class="xn" href="'+esc(sp.getAttribute('data-u'))+'">'+esc(sp.getAttribute('data-t'))+'</a><span class="xp">'+esc(sp.getAttribute('data-p'))+'</span></div>'+
        '<button class="xadd" data-cc-xs-add data-vid="'+esc(sp.getAttribute('data-v'))+'">'+esc(addLabel)+'</button></div>';
    }).join('');
    xs.style.display='';
    slot.querySelectorAll('[data-cc-xs-add]').forEach(function(b){ b.onclick=function(){ b.disabled=true; b.textContent='…'; addVariant(b.getAttribute('data-vid')); }; });
  }

              /* ===== commande doublée (Black Month) ===== */
  /* Pour chaque ligne payante éligible, le panier doit contenir la ligne JUMELLE
     à 0 € (produit « … (×2 offert) », tag cbde-x2) dans la quantité voulue.
     Table de correspondance : assets/cbde-x2.json (_bm_x2_creer.mjs + _bm_x2_json.mjs).
     Aucune remise Shopify en jeu : la jumelle est à 0,00 € en dur.

     🧨 On lit l'état du panier dans /cart.js, JAMAIS dans le HTML rendu du tiroir :
     le corps affiché peut dater d'avant le dernier ajout (la Section Rendering API
     et nos propres écritures se croisent), et une quantité en retard faisait
     n'ajouter qu'une jumelle pour deux articles payés.

     Appelé après chaque rendu du corps (bindBody, donc aussi au chargement de page)
     et sur l'évènement d'ajout au panier du thème. */
  var X2 = null, x2Req = null, x2Jum = null;
  var x2Busy = false, x2Redo = false, x2Passes = 0;

  function loadX2(){
    if(X2) return Promise.resolve(X2);
    if(x2Req) return x2Req;
    var u = root && root.getAttribute('data-x2map');
    if(!u) return Promise.resolve(null);
    x2Req = fetch(u, {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        X2 = (j && j.twin) ? j : null;
        if(X2){ x2Jum = {}; for(var k in X2.twin) x2Jum[X2.twin[k]] = 1; }
        return X2;
      })
      .catch(function(){ return null; });
    return x2Req;
  }

  /* écart entre ce que le panier contient en jumelles et ce qu'il devrait contenir */
  function x2Ecart(cart){
    var veut = {}, a = {};
    (cart.items || []).forEach(function(i){
      var vid = String(i.variant_id);
      if(x2Jum[vid]){ a[vid] = (a[vid] || 0) + i.quantity; return; }   /* une jumelle */
      var j = X2.twin[vid];
      if(!j) return;                                                   /* non doublable */
      veut[j] = (veut[j] || 0) + i.quantity * (X2.mult[vid] || 1);
    });
    var baisses = {}, ajouts = [], n = 0, k;
    for(k in a){ var cible = veut[k] || 0; if(cible < a[k]){ baisses[k] = cible; n++; } }
    for(k in veut){ var dejala = a[k] || 0; if(dejala < veut[k]){ ajouts.push({ id: parseInt(k,10), quantity: veut[k] - dejala }); n++; } }
    return { baisses: baisses, ajouts: ajouts, n: n };
  }

  function x2Post(url, corps){
    corps.sections = SECTION;
    return fetch(url, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify(corps)}).then(function(r){ return r.json(); });
  }

  function x2Fini(){ x2Busy = false; if(x2Redo){ x2Redo = false; syncX2(); } }

  function syncX2(){
    loadX2().then(function(m){
      if(!m || !root) return;
      if(x2Busy){ x2Redo = true; return; }          /* une synchro tourne : on repassera */
      x2Busy = true;
      fetch('/cart.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var e = x2Ecart(cart);
          if(!e.n){ x2Passes = 0; x2Fini(); return; }               /* panier cohérent */
          if(x2Passes > 12){ x2Busy = false; return; }              /* sécurité anti-boucle */
          x2Passes++;
          var suite = Promise.resolve(null);
          if(Object.keys(e.baisses).length) suite = suite.then(function(){ return x2Post('/cart/update.js', { updates: e.baisses }); });
          if(e.ajouts.length) suite = suite.then(function(){ return x2Post('/cart/add.js', { items: e.ajouts }); });
          suite.then(function(j){
            x2Busy = false; x2Redo = false;
            /* swapBody rappelle bindBody -> syncX2 : la passe suivante relit /cart.js
               et s'arrête d'elle-même quand il n'y a plus d'écart */
            if(j && j.sections && j.sections[SECTION]) swapBody(j.sections[SECTION], j.total_price);
            else refresh();
          }, function(){ x2Busy = false; });
        }, function(){ x2Busy = false; });
    });
  }
  /* ===== cadeaux : droits, encart et sous-écran de choix ===== */
  /* Le catalogue (assets/cbde-cadeaux.json) est produit par _cadeaux_export.mjs
     à partir des offres Bogos. Les droits sont recalculés à chaque rendu du corps :
     montant éligible par offre (filtré sur ses collections) >= seuil => 1 emplacement. */
  var GIFTS = null, giftsReq = null, subOn = false, subSlot = 0, subMode = 'choix', purging = false, purges = 0;

  function loadGifts(){
    if(GIFTS) return Promise.resolve(GIFTS);
    if(giftsReq) return giftsReq;
    var u = root && root.getAttribute('data-gifts');
    if(!u) return Promise.resolve(null);
    giftsReq = fetch(u, {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ GIFTS = (j && j.offres) ? j : null; return GIFTS; })
      .catch(function(){ return null; });
    return giftsReq;
  }

  function gtxt(k, def){ var v = root && root.getAttribute('data-g-'+k); return v || def || ''; }

  function cartLines(){
    return [].map.call(root.querySelectorAll('[data-cc-line]'), function(li){
      var cols = li.getAttribute('data-cols') || '';
      var brut = root.getAttribute('data-gbase') === 'brut';
      return { line: parseInt(li.getAttribute('data-cc-line'),10),
               key: li.getAttribute('data-key'),
               vid: li.getAttribute('data-vid') || '',
               prix: parseInt(li.getAttribute(brut ? 'data-lo' : 'data-lp'),10) || 0,
               cadeau: li.getAttribute('data-gift') === '1',
               cols: cols ? cols.split(',') : [] };
    });
  }

  function offreContient(o, vid){
    for(var i=0;i<o.gifts.length;i++) if(o.gifts[i].v === vid) return true;
    return false;
  }
  function connuAuCatalogue(vid){
    for(var i=0;i<GIFTS.offres.length;i++) if(offreContient(GIFTS.offres[i], vid)) return true;
    return false;
  }

  /* montant du panier retenu pour une offre : seules comptent les lignes payantes
     appartenant à l'une de ses collections (cols null = tout le panier) */
  function montantEligible(o, payantes){
    var t = 0;
    for(var i=0;i<payantes.length;i++){
      var l = payantes[i];
      if(!o.cols){ t += l.prix; continue; }
      for(var j=0;j<l.cols.length;j++){ if(o.cols.indexOf(l.cols[j]) >= 0){ t += l.prix; break; } }
    }
    return t;
  }

  /* emplacements gagnés + affectation des cadeaux déjà au panier */
  function etatCadeaux(){
    if(!GIFTS) return null;
    var lignes = cartLines();
    var payantes = [], auPanier = [];
    lignes.forEach(function(l){ (l.cadeau ? auPanier : payantes).push(l); });

    var slots = [];
    GIFTS.offres.forEach(function(o){
      var t = montantEligible(o, payantes);
      if(t < o.min) return;
      if(o.max != null && t > o.max) return;
      for(var k=0;k<(o.n||1);k++) slots.push({ o:o, pris:null });
    });

    /* les cadeaux acceptés par le moins d'emplacements sont placés en premier */
    auPanier.sort(function(a,b){
      var na=0, nb=0;
      slots.forEach(function(s){ if(offreContient(s.o,a.vid)) na++; if(offreContient(s.o,b.vid)) nb++; });
      return na-nb;
    });

    var orphelins = [];
    auPanier.forEach(function(l){
      for(var i=0;i<slots.length;i++){
        if(!slots[i].pris && offreContient(slots[i].o, l.vid)){ slots[i].pris = l; return; }
      }
      if(connuAuCatalogue(l.vid)) orphelins.push(l);
    });

    var libres = 0;
    slots.forEach(function(s){ if(!s.pris) libres++; });
    return { slots:slots, libres:libres, orphelins:orphelins };
  }

  function changeParCle(key, qty){
    return fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id:key, quantity:qty, sections:SECTION })})
      .then(function(r){return r.json();})
      .then(function(j){ if(j.sections && j.sections[SECTION]) swapBody(j.sections[SECTION], j.total_price); });
  }

  /* ---- encart dans le panier ---- */
  function peindreEncart(st){
    var slot = root.querySelector('[data-cc-gifts]');
    if(!slot) return;
    if(!st || !st.slots.length){ slot.innerHTML = ''; return; }
    var n = st.libres, tous = st.slots.length;
    var titre = n === 0 ? gtxt('allok') : gtxt('remind');
    var dessous = n === 0 ? (tous + ' ' + gtxt('of','sur') + ' ' + tous)
                          : (n === 1 ? gtxt('one') : gtxt('many').replace('{n}', n));
    var bouton = n === 0 ? gtxt('chg','Modifier') : gtxt('go','Choisir');
    slot.innerHTML = '<div class="cc-gift-box'+(n===0?' ok':'')+'">'+
      '<div class="cc-gift-hd"><span class="ic" aria-hidden="true">🎁</span>'+
      '<span class="tx"><b>'+esc(titre)+'</b><span>'+esc(dessous)+'</span></span>'+
      '<button class="cc-gift-go" data-cc-gift-open>'+esc(bouton)+'</button></div></div>';
    var b = slot.querySelector('[data-cc-gift-open]');
    if(b) b.onclick = ouvrirSub;
  }

  /* rappel cliquable juste au-dessus du bouton Paiement, tant qu'il reste des cadeaux
     à prendre. On ne bloque JAMAIS le paiement : un cadeau non réclamé ne doit pas
     pouvoir empêcher une commande (catalogue périmé, clone en rupture, JS en panne…). */
  function peindreRappel(st){
    var slot = root.querySelector('[data-cc-gift-nudge]');
    if(!slot) return;
    if(!st || !st.libres){ slot.innerHTML = ''; return; }
    var t = st.libres === 1 ? gtxt('nudge1') : gtxt('nudge').replace('{n}', st.libres);
    slot.innerHTML = '<button class="cc-nudge" data-cc-nudge-go>'+
      '<span aria-hidden="true">🎁</span><span>'+esc(t)+'</span>'+
      '<span class="ar" aria-hidden="true">›</span></button>';
    slot.querySelector('[data-cc-nudge-go]').onclick = ouvrirSub;
  }

  /* ---- sous-écran ---- */
  function peindreSub(st){
    var slots = root.querySelector('[data-cc-slots]');
    var liste = root.querySelector('[data-cc-gl]');
    var cpt = root.querySelector('[data-cc-sub-ct]');
    if(!slots || !liste) return;
    if(!st || !st.slots.length){ fermerSub(); return; }
    if(subSlot >= st.slots.length) subSlot = 0;

    var pris = st.slots.length - st.libres;
    if(cpt) cpt.textContent = pris + ' ' + gtxt('of','sur') + ' ' + st.slots.length;

    slots.innerHTML = st.slots.map(function(s, i){
      var lib = (s.o.court || s.o.nom) + ' · ' + Math.round(s.o.min/100) + ' €';
      return '<button class="cc-slot'+(i===subSlot?' on':'')+(s.pris?' ok':'')+'" data-cc-slot="'+i+'">'+
             (s.pris?'✓ ':'')+esc(lib)+'</button>';
    }).join('');
    [].forEach.call(slots.querySelectorAll('[data-cc-slot]'), function(b){
      b.onclick = function(){ subSlot = parseInt(b.getAttribute('data-cc-slot'),10); peindreSub(etatCadeaux()); };
    });
    var act = slots.querySelector('.cc-slot.on');
    if(act && act.scrollIntoView) try{ act.scrollIntoView({block:'nearest', inline:'nearest'}); }catch(e){}

    var cour = st.slots[subSlot];
    /* une variante déjà posée sur un AUTRE emplacement ne peut pas être reprise ici */
    var ailleurs = {};
    st.slots.forEach(function(s,i){ if(s.pris && i !== subSlot) ailleurs[s.pris.vid] = true; });

    liste.innerHTML = cour.o.gifts.map(function(g){
      if(ailleurs[g.v]) return '';
      var choisi = cour.pris && cour.pris.vid === g.v;
      return '<li class="'+(choisi?'sel':'')+'">'+
        (g.i ? '<img src="'+esc(g.i)+'" alt="" width="48" height="48" loading="lazy">' : '<img alt="" width="48" height="48">')+
        '<div class="t"><b>'+esc(g.t)+'</b><span>'+esc(g.f || '')+'</span></div>'+
        '<button data-cc-pick="'+esc(g.v)+'">'+esc(choisi ? gtxt('pckd','✓') : gtxt('pick','Choisir'))+'</button></li>';
    }).join('');
    [].forEach.call(liste.querySelectorAll('[data-cc-pick]'), function(b){
      b.onclick = function(){ choisirCadeau(b, b.getAttribute('data-cc-pick')); };
    });
  }

  function choisirCadeau(bouton, vid){
    var st = etatCadeaux(); if(!st) return;
    var cour = st.slots[subSlot]; if(!cour) return;
    if(cour.pris && cour.pris.vid === vid) return;          /* déjà celui-là */
    [].forEach.call(root.querySelectorAll('[data-cc-pick]'), function(x){ x.disabled = true; });
    bouton.textContent = '…';
    var avant = cour.pris ? changeParCle(cour.pris.key, 0) : Promise.resolve();
    avant.then(function(){
      return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id:parseInt(vid,10), quantity:1 }] })});
    }).then(function(){ return refresh(); })
      .then(function(){
        var ap = etatCadeaux();
        if(!ap) return;
        /* dernier emplacement rempli : on rend la main au panier plutôt que de laisser
           le client remplacer son choix en boucle sans s'en rendre compte */
        if(!ap.libres && subMode === 'choix'){ fermerSub(); return; }
        if(!ap.libres){ peindreSub(ap); return; }   /* mode « Modifier » : on reste */
        for(var i=0;i<ap.slots.length;i++){ if(!ap.slots[i].pris){ subSlot = i; break; } }
        peindreSub(ap);
      })
      .catch(function(){ refresh(); });
  }

  function ouvrirSub(){
    var el = root.querySelector('[data-cc-sub]'); if(!el) return;
    var st = etatCadeaux(); if(!st || !st.slots.length) return;
    /* « Choisir » (il reste des emplacements) ferme l'écran au dernier choix ;
       « Modifier » (tout est pris) laisse le client enchaîner les changements */
    subMode = st.libres ? 'choix' : 'edition';
    subSlot = 0;
    for(var i=0;i<st.slots.length;i++){ if(!st.slots[i].pris){ subSlot = i; break; } }
    peindreSub(st);
    el.classList.add('is-on'); el.setAttribute('aria-hidden','false'); subOn = true;
  }
  function fermerSub(){
    var el = root.querySelector('[data-cc-sub]'); if(!el) return;
    el.classList.remove('is-on'); el.setAttribute('aria-hidden','true'); subOn = false;
  }

  /* ---- point d'entrée appelé après chaque rendu du corps ---- */
  function renderGifts(){
    loadGifts().then(function(g){
      if(!g || !root) return;
      var st = etatCadeaux();
      /* un cadeau que le panier ne justifie plus (seuil repassé en dessous) repart */
      if(st && st.orphelins.length && !purging && purges < 20){
        purging = true; purges++;
        var fini = function(){ purging = false; renderGifts(); };
        changeParCle(st.orphelins[0].key, 0).then(fini, function(){ purging = false; });
        return;
      }
      peindreEncart(st);
      peindreRappel(st);
      if(subOn) peindreSub(st);
      if(st && !st.slots.length) fermerSub();
    });
  }

  function wireGiftScreen(){
    var b = root.querySelector('[data-cc-sub-back]'); if(b) b.onclick = fermerSub;
    var d = root.querySelector('[data-cc-sub-done]'); if(d) d.onclick = fermerSub;
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && subOn){ e.stopPropagation(); fermerSub(); } }, true);
  }

  /* ---- global wiring ---- */
  function wire(){
    if(!el()) return;
    root.querySelectorAll('[data-cc-close]').forEach(function(b){ b.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
    /* cart icon(s) -> open our drawer : DÉLÉGATION (survit aux re-renders + au timing) */
    document.addEventListener('click', function(e){
      var t = e.target && e.target.closest ? e.target.closest('a[href], .cbde-icon-btn, [data-cbde-cart-open]') : null;
      if(!t) return;
      var href = t.getAttribute('href') || '';
      var lbl = (t.getAttribute('aria-label')||'') + ' ' + (t.getAttribute('title')||'');
      var isCart = /\/cart(\?|$|\/)/.test(href)
        || t.hasAttribute('data-cbde-cart-open')
        || ((t.classList && t.classList.contains('cbde-icon-btn')) && /panier|cart/i.test(lbl));
      if(!isCart) return;
      e.preventDefault(); e.stopPropagation(); refresh().then(open);
    }, true);
    /* theme hooks from cbde-card.js */
    if(!window.theme) window.theme={};
    window.theme.openCart = function(){ refresh().then(open); };
    document.addEventListener('cart:open', function(){ refresh().then(open); });
    document.addEventListener('cbde:cart:added', function(){ refresh().then(open); });
    try{ applied.code = localStorage.getItem('cbde_promo')||''; }catch(e){}
    bindBody();
    wireGiftScreen();
    document.addEventListener('cbde:cart:added', syncX2);
    document.addEventListener('cart:open', syncX2);
    /* ouverture auto après redirection depuis /cart */
    try{ if(new URLSearchParams(location.search).has('cc_open')){ refresh().then(open); history.replaceState(null,'',location.pathname); } }catch(e){}
  }

  if(document.readyState!=='loading') wire(); else document.addEventListener('DOMContentLoaded', wire);
})();
